import React from "react";
import Text from "components/Text";
import tooltipImg from "assets/images/info_black-tooltip.svg";
import styles from "../AddStaff.module.scss"

const PrivacyNotice = ({ address, socialSecurityNumber }) => {
  return (
    <div className={`p-4 bg-white c-field ${styles["personal-contact-card"]}`}>
      <div className="cbg-warning p-2 d-flex gap-xxs align-items-start">
        <img src={tooltipImg} id="pick-color" alt="tooltip" className="ml-2" />
        <Text size="10px" weight="500" color="#2D3245">
          For privacy and compliance, Address and Social Insurance Number (SIN)
          can only be entered by the staff member. They'll appear here once
          submitted.
        </Text>
      </div>
      <Text size="12px" weight="400" color="#6F7788" className="mt-2">
        Address
      </Text>
      <Text className=" text-wrap text-break" size="14px" weight="600" color="#102C42">
        {address || "--"}
      </Text>
      <Text size="12px" weight="400" color="#6F7788" className="mt-2">
        Social Security Number
      </Text>
      <Text size="14px" weight="600" color="#102C42">
        {socialSecurityNumber || "--"}
      </Text>
    </div>
  );
};

export default PrivacyNotice;
